<template>
  <edit-sidebar class="editPurpose">
    <div class="part">
      <h2>Purpose</h2>
      <form class="sentry-masked-text" @submit.prevent @keyup.enter.exact="saveAndReturn">
        <app-auto-textarea :modelValue="field" late-focus="true" placeholder="Add Meeting Purpose..." :limit="255" @update:modelValue="handleInput" />
      </form>
      <app-text-limit-message :limit="255" :warn-limit="200" :value="field" />
      <div class="actions btn-pair">
        <button type="button" @click.prevent="cancel()">Cancel</button>
        <button type="button" @click.prevent="saveAndReturn()">Save</button>
      </div>
    </div>
  </edit-sidebar>
</template>

<script setup>
import { ref, watch, nextTick, getCurrentInstance } from 'vue';
import { storeToRefs } from 'pinia';
import AppAutoTextarea from '@/components/AppAutoTextarea.vue';
import AppTextLimitMessage from '@/components/AppTextLimitMessage.vue';
import EditSidebar from '@/components/EditSidebar.vue';
import { useSidebarStore } from '@/store/pinia/sidebar';
import { useMeetingStore } from '@/store/pinia/meeting';
import utils from '../resources/utils.js';
const { $meetingmanager } = getCurrentInstance().appContext.config.globalProperties;

const props = defineProps({
  focusing: {
    type: Boolean,
    default: false,
  },
  extra: {
    type: Boolean,
    default: false,
  },
});

const meetingStore = useMeetingStore();
const sidebarStore = useSidebarStore();

const field = ref('');
const { purpose: fieldContent } = storeToRefs(meetingStore);

watch(
  fieldContent,
  (nv) => {
    field.value = utils.desanitizeString(nv);
  },
  { immediate: true },
);

function handleInput(e) {
  field.value = e;
}
function saveAndReturn() {
  meetingStore.updateLocalMeetingInfo({ prop: 'purpose', value: field.value || '' });
  $meetingmanager.updateMeeting({
    purpose: field.value || '',
    trigger: 'purpose',
  });
  nextTick(() => {
    sidebarStore.finishedWithPane(props.extra);
  });
}
function cancel() {
  sidebarStore.finishedWithPane(props.extra);
}
</script>
